import { gql } from '@apollo/client/core';

export const getAORs = gql`
  query getAORs($businessUnits: [String]) {
    getAORs(businessUnits: $businessUnits) {
      enabled
      id
      name
      version
      businessUnitId
      abbreviation
      isPrimary
      AORSubSystems {
        id
        aorId
        name
        enabled
        deletedAt
      }
    }
  }
`;
